import { mapGetters } from 'vuex'
export default {
	data() {
		return {
			showPassword: false,
			showOldPassword: false,
			showConfirmPassword: false,
			formValid: false,
			formData: {
				password: '',
				old_password: '',
				confirm_password: '',
			},
		}
	},
	computed: {
		...mapGetters({
			loading: 'themes/player/loading',
		}),
		formRule() {
			return {
				password: [
					(v) => !!v || this.tl('passwordIsRequired'),
					(v) => (v && v.length >= 6) || this.tl('passwordGreaterThan'),
				],
				old_password: [
					(v) => !!v || this.tl('oldPasswordIsRequired'),
					(v) => (v && v.length >= 6) || this.tl('passwordGreaterThan'),
				],
				confirm_password:
					this.formData.password && this.formData.confirm_password
						? [
							(v) =>
								this.formData.password === v ||
								this.tl('passwordNotMatch'),
						]
						: [
							(v) =>
								!!v || this.tl('confirmPasswordIsRequired'),
							(v) =>
								(v && v.length >= 6) ||
								this.tl('passwordGreaterThan'),
						],
			}
		},
	},
	methods: {
		async changePassword() {
			await this.$refs?.refPassword?.validate()
			if (this.formValid) {
				const result = await this.$store.dispatch(
					'themes/player/doResetPassword',
					{
						...this.formData,
					}
				)
				if (result) {
					this.$refs?.refPassword?.reset()
				}
			}
		},
		resetForm() {
			this.$refs?.refPassword?.reset()
		},
	}
}